module.exports = __webpack_public_path__ + "img/smok_vape_3.53627dd6.png";